import React, { useEffect, useState } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { FlashList } from '@shopify/flash-list'
import { Answer } from './interfaces/FieldAssesment.interface'
import { SinoNaIEditItem } from './FormItems/NoEdit/SinoNaIEditItem'
import { InputEditItem } from './FormItems/NoEdit/InputEditItem'
import styles from './FormAnswersStyles'

export const FormAnswers = ({ answers }) => {
    console.log('🚀 ~ file: FormAnswers.tsx:11 ~ FormAnswers ~ params:', answers)

    return (
        <View style={styles.container}>
            <FlashList
                data={answers}
                renderItem={({ item, index }) => <ItemNoEditable item={item} />}
                ItemSeparatorComponent={() => <View style={{ marginVertical: 0 }} />}
            />
        </View>
    )
}

export const ItemNoEditable = ({ item }) => {
    const [itemRender, setItemRender] = useState<null | Answer>(null)

    useEffect(() => {
        setItemRender(item)
    }, [item])

    return (
        <>
            {(() => {
                switch (itemRender?.questionType?.type) {
                    case 7:
                    case 8:
                    case 14:
                    case 18:
                        return <SinoNaIEditItem item={item} />

                    case 10:
                    case 36:
                    case 38:
                        return <InputEditItem item={item} />
                    default:
                        return <Text>{item.title} no estoy mapeado no te asustes</Text>
                }
            })()}
        </>
    )
}
